var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTatodomundoplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1133.24 670.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fefefe;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #ffaf00;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #575f63;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #e24b4b;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #009cb6;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #3e4347;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #ffc615;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #ff5d31;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #bbc7d1;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #ffa489;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #ffda1c;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.26,576.21c-11.68,4.68-23.06,9.01-34.09,13.03-4.38,9.24-13.89,15.58-26.57,15.58h-19.01c-15.07,4.82-29.05,8.94-41.67,12.45v44.8h29.91v-31.62h29.27c40.81,0,62.17-23.93,62.17-53.41,0-.28,0-.55-.01-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m573.06,298.95l-26.7,151.26h-47.43l-36.75-76.06-13.46,76.06h-47.42l5.75-32.55c29.76-25.52,58.18-53.84,84.19-85.23l20.72,43.86,13.67-77.34h47.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m639.55,151.4c0,40.93-31.91,71.04-75.4,71.51,6.22-11.99,12.11-24.31,17.6-36.98,11.14-6.31,18.5-18.56,18.5-34.53,0-3.66-.39-7.13-1.12-10.37,5.01-14.67,9.52-29.76,13.48-45.28,16.74,12.82,26.94,32.5,26.94,55.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m698.22,523.63v83.32c0,36.53-24.36,57.47-59.82,57.47-9.76,0-18.69-1.59-26.49-4.65l9.22-27.13c4.7,2.94,10.54,4.43,17.27,4.43,18.16,0,29.91-10.89,29.91-31.61v-81.83h29.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m694.16,379.13c-2.28,8.44-6.51,15.11-12.68,20.02-7.33,5.84-16.34,8.75-27.02,8.75h-11.32l11.96-67.51h11.32c7.02,0,12.87,1.27,17.55,3.81-2.33-14.25-2.84-29.36-1.73-45.16-1.41-.06-2.83-.09-4.28-.09h-63.02l-26.71,151.26h63.02c15.81,0,30.23-3.32,43.27-9.94,10.7-5.44,19.87-12.54,27.5-21.3-12.17-11.76-21.35-25.13-27.86-39.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m727.17,82.63h-65.03v137.54h36.43c3.29-10.21,7.03-20.57,11.17-31.04h-8.7v-75.45h24.56c6.59,0,12.58,1.11,17.77,3.24,5.12-9.68,10.5-19.39,16.11-29.11-9.6-3.39-20.47-5.18-32.31-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m977.87,621.48c0,29.91-29.05,42.94-56.83,42.94-33.11,0-48.71-12.6-56.4-18.8l10.9-23.07c11.11,8.11,24.35,15.17,45.5,15.17,11.54,0,25.64-5.35,25.64-16.24s-12.39-13.46-24.57-16.45c-25.85-5.98-52.55-14.74-52.55-43.58,0-26.71,24.99-39.95,51.48-39.95,20.94,0,36.75,5.55,50.64,14.74l-10.9,23.07c-11.11-7.26-25.63-11.11-39.74-11.11-7.26,0-20.93,2.78-20.93,13.25,0,8.97,10.04,12.17,23.71,15.38,24.57,5.77,54.05,14.95,54.05,44.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m744.62,358.98c0,4.7-.43,9.76-1.29,15.17-2.56,14.39-8.08,27.35-16.55,38.88-1.51,2.06-3.1,4.04-4.76,5.94-12.17-11.76-21.35-25.13-27.86-39.84.44-1.59.8-3.25,1.1-4.98.43-2.85.65-5.48.65-7.91,0-8.4-2.61-14.81-7.8-19.22-1.26-1.07-2.64-2.01-4.14-2.82-2.33-14.25-2.84-29.36-1.73-45.16,12.14.46,22.67,2.96,31.61,7.49,9.97,5.06,17.59,12.11,22.86,21.15,5.27,9.05,7.91,19.48,7.91,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m804,151.4c0,42.25-31.24,68.77-76.83,68.77h-28.6c3.29-10.21,7.03-20.57,11.17-31.04h15.86c23.39,0,39.1-13.95,39.1-37.73,0-17.07-8.1-29.07-21.33-34.48,5.12-9.68,10.5-19.39,16.11-29.11,27.39,9.65,44.52,32.32,44.52,63.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m895.95,79.88c-44.01,0-76.43,30.26-76.43,71.52s32.42,71.52,76.43,71.52,76.44-30.26,76.44-71.52-32.43-71.52-76.44-71.52Zm0,110.82c-20.83,0-37.13-15.52-37.13-39.3s16.3-39.3,37.13-39.3,37.14,15.53,37.14,39.3-16.31,39.3-37.14,39.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "335.24 636.43 415.36 636.43 415.36 662.07 305.34 662.07 305.34 523.63 335.24 523.63 335.24 636.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m621.13,632.64l-9.22,27.13c-20.54-8.06-33.33-26.35-33.33-52.82v-83.32h29.91v81.83c0,13.05,4.66,22.2,12.64,27.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m104.17,589.24c1.75-3.68,2.69-7.82,2.69-12.2,0-15.38-11.53-27.77-29.05-27.77h-30.98v55.55h11.76c-15.07,4.82-29.05,8.94-41.67,12.45v-93.64h59.39c40.22,0,61.56,23.48,61.95,52.58-11.68,4.68-23.06,9.01-34.09,13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m62.44,384.27l-11.51,65.94H3.5l11.89-67.33c14.21,1.39,30.1,2.08,47.05,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m204.98,338.75l-19.67,111.46h-47.22l13.25-75.21-36.53,75.21h-40.59l-8.75-66.08c12.29-.61,25.11-1.97,38.22-4.32,2.72-.48,5.45-1.01,8.19-1.59,30.72-6.43,62.75-18.51,93.1-39.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m339.77,298.95h47.21l-14.95,85.24c-2.57,14.82-7.66,27.28-15.28,37.39-7.62,10.11-16.95,17.66-27.98,22.64-11.04,4.99-23.18,7.48-36.43,7.48-16.95,0-30.48-4.45-40.59-13.35-10.12-8.9-15.17-21.61-15.17-38.14,0-5.26.5-10.6,1.5-16.02l14.95-85.24h47.22l-14.96,85.24c-.43,2.28-.64,4.63-.64,7.05,0,4.84,1.28,8.65,3.85,11.43,2.56,2.78,6.62,4.17,12.17,4.17,6.84,0,12.25-2.03,16.24-6.09,3.99-4.06,6.62-9.58,7.9-16.56l14.96-85.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m395.51,220.17v-107.08c-12.57,2.16-24.16,6.48-35.17,12.77l-12.97-28.3c19.46-11.78,43.23-17.68,67.6-17.68s48.33,5.9,67.59,17.68l-12.97,28.3c-11.2-6.29-22.6-10.61-35.17-12.77v107.08h-38.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m491.24,332.43c-26.01,31.39-54.43,59.71-84.19,85.23l20.95-118.71h47.43l15.81,33.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m612.61,95.75c-3.96,15.52-8.47,30.61-13.48,45.28-4.01-17.82-18.4-28.93-36.02-28.93-20.82,0-37.13,15.53-37.13,39.3s16.31,39.3,37.13,39.3c6.84,0,13.19-1.67,18.64-4.77-5.49,12.67-11.38,24.99-17.6,36.98-.34.01-.69.01-1.04.01-44.01,0-76.43-30.26-76.43-71.52s32.42-71.52,76.43-71.52c19.32,0,36.41,5.83,49.5,15.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m103.69,379.81c-13.11,2.35-25.93,3.71-38.22,4.32-1.01.05-2.02.1-3.03.14-16.95.69-32.84,0-47.05-1.39l14.82-83.93h58.11l15.37,80.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m48.14,113.09c-12.58,2.16-24.17,6.48-35.17,12.77L0,97.56c19.45-11.78,43.23-17.68,67.59-17.68s48.34,5.9,67.59,17.68l-12.97,28.3c-11.2-6.29-22.59-10.61-35.17-12.77v107.08h-38.9v-107.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m212.01,298.95l-7.03,39.8c-30.35,20.96-62.38,33.04-93.1,39.47l42.24-79.27h57.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "218.1 71.43 191.37 71.43 217.7 41.57 255.04 41.57 218.1 71.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m210.63,79.88c-38.9,0-65.43,23.58-65.43,66.02v74.27h38.31v-30.45h53.65v30.45h38.9v-74.27c0-42.44-26.53-66.02-65.43-66.02Zm26.53,79.77h-53.65v-17.09c0-20.83,11.01-30.46,26.92-30.46s26.73,9.63,26.73,30.46v17.09Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "al\\xE7a1",
    className: "cls-10",
    d: "m773.99,353.27c3.72-48.27,50.45-84.17,104.17-80.03,53.72,4.14,94.41,46.77,90.69,95.04-.24,3.07-.65,6.08-1.22,9.04,4.75.69,12.31,15.12,14.22,2.16,1.21-8.2,1.06-6.69,1.32-10.09,2.11-27.34-7.63-53.91-27.42-74.81-19.6-20.7-46.77-33.37-76.49-35.66-29.72-2.29-58.5,6.06-81.04,23.52-22.76,17.62-36.45,42.39-38.56,69.73-.3,3.85-.15-.75-.18,11.5-.03,12.25,9.45-2.9,14.28-3.25-.03-2.37.04-4.75.22-7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al\\xE7a2",
    className: "cls-6",
    d: "m937.18,296.47c-2.35,2.24-6,2.37-8.48.28-12.2-10.26-31.02-17.16-51.64-18.75-19.93-1.53-39.15,2.15-52.74,9.94-2.82,1.62-6.41.84-8.32-1.79l-7.14-9.85c-2.18-3.01-1.36-7.28,1.84-9.19,18.14-10.84,42.59-15.88,68.28-13.9,26.62,2.05,50.54,11.22,66.83,25.45,2.82,2.46,2.9,6.83.19,9.41l-8.81,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m777.62,354.14s-18.37-3.38-20.85,28.8,17.54,31.97,17.54,31.97l7.2-60.49-3.89-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m800.47,339.35s-23.05-10.58-30.49,37.75c-7.44,48.32,16.81,58.54,23.28,55.84,6.47-2.7,23.51-46.17,23.51-46.17l-16.3-47.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m965.81,368.64s18.67-.53,16.19,31.66c-2.48,32.19-22.23,28.9-22.23,28.9l2.15-60.88,3.89.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m945.5,350.52s24.4-6.92,24.35,41.97c-.05,48.89-25.58,55.27-31.55,51.62-5.98-3.65-16.16-49.23-16.16-49.23l23.37-44.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m955.53,398.25c-3.68,47.76-45.39,83.5-93.15,79.82-22.23-1.71-41.85-11.66-56.11-26.62-2.74-2.88-5.29-5.94-7.61-9.16-11.57-16.04-17.74-36.1-16.1-57.36,3.68-47.76,45.39-83.5,93.15-79.82,19.54,1.51,37.07,9.37,50.7,21.41,5.12,4.52,9.69,9.62,13.61,15.2,11.19,15.9,17.12,35.64,15.51,56.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m942.52,383.9c-3.68,47.76-45.38,83.5-93.15,79.82-19.55-1.51-37.07-9.38-50.71-21.42-11.57-16.04-17.74-36.1-16.1-57.36,3.68-47.76,45.39-83.5,93.15-79.82,19.54,1.51,37.07,9.37,50.7,21.41.2.28.4.56.6.84,11.19,15.9,17.12,35.63,15.51,56.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "olho",
    className: "cls-7",
    cx: 837.49,
    cy: 372.48,
    r: 26.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "pupila",
    className: "cls-6",
    cx: 837.49,
    cy: 372.48,
    r: 11.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "brilho",
    className: "cls-1",
    cx: 841.87,
    cy: 368.55,
    rx: 2.47,
    ry: 4.23,
    transform: "translate(-46.8 602.73) rotate(-38.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "olho-2",
    "data-name": "olho",
    className: "cls-7",
    cx: 903.34,
    cy: 377.55,
    r: 26.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "pupila-2",
    "data-name": "pupila",
    className: "cls-6",
    cx: 903.34,
    cy: 377.55,
    r: 11.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "brilho-2",
    "data-name": "brilho",
    className: "cls-1",
    cx: 907.72,
    cy: 373.62,
    rx: 2.47,
    ry: 4.23,
    transform: "translate(-35.7 644.74) rotate(-38.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m913.32,427.24c-2.82,9.4-10.13,17.19-19.94,22.04-8.19,4.06-18.12,6.07-28.65,5.26-8.23-.63-15.84-2.92-22.33-6.4-11.77-6.3-19.9-16.54-21.5-28.02-.4-2.87,1.92-5.38,4.8-5.16l1.92.15.86.19,12.25,2.67c17.15,3.73,34.71,5.17,52.24,4.28l12.49-.64,3.91-.2c2.89.22,4.79,3.06,3.96,5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m893.38,449.28c-8.19,4.06-18.12,6.07-28.65,5.26-8.23-.63-15.84-2.92-22.33-6.4,1.18-1.77,5.97-8.95,10.22-7.87,4.79,1.22,10.67,5.39,27.19-1.75,4.65-1.61,10.5,4.38,13.58,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m905.46,421.6c-3.29,7.01-12.36,11.66-22.55,10.87l-33.7-2.6c-10.37-.8-18.73-6.97-20.73-14.58l12.25,2.67c17.15,3.73,34.71,5.17,52.24,4.28l12.49-.64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTatodomundoplus);
export default __webpack_public_path__ + "static/media/tatodomundoplus.64cfbd18fe12ba42b5b0fd1d0b42339e.svg";
export { ForwardRef as ReactComponent };